import useSWR, { KeyedMutator } from "swr";
import { useDataCleaningContext } from "../context/data-cleaning-context";
import {
  FieldFilterDataItem,
  FieldFilterDataResponse,
  getFieldFilterData,
} from "../services/cleaning-data-service";

export interface UseFieldFilterModel {
  data: FieldFilterDataItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<FieldFilterDataResponse>;
}

const useFieldFilterData = (): UseFieldFilterModel => {
  const { selection } = useDataCleaningContext();

  if (!selection.selectedFieldId) {
    throw new Error("Selected field ID is required to fetch filter data.");
  }

  const { data, error, mutate } = useSWR(
    `/cleaning/field/${selection.selectedFieldId}/filter`,
    () => getFieldFilterData(selection.selectedFieldId as number),
  );

  return {
    data: data?.results,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useFieldFilterData;
